<template>
  <div ref="target">
    <slot />
  </div>
</template>

<script setup>
import { useIntersectionObserver } from '@vueuse/core'
import { ref, onMounted } from 'vue'

const root = ref(null)
const target = ref(null)

const emit = defineEmits(['intersect-enter', 'intersect-leave'])

/**
 * A wrapping component for IntersectionObserver api.
 * Emits following events:
 * - `intersect-enter` - emitted when an element enters the view
 * - `intersect-leave` - emitted when an element leaves the view
 */

onMounted(async () => {
  useIntersectionObserver(
    target,
    ([{ isIntersecting }]) => {
      if (isIntersecting) {
        emit('intersect-enter')
      } else {
        emit('intersect-leave')
      }
    },
    { root }
  )
})
</script>
